import { fetchBlockBanner, fetchSearchProducts, getPromotions } from "api/interna-api";
import Button from "components/atoms/Button";
import Heading from "components/atoms/Heading";
import Icon from "components/atoms/Icon";
import Image from "components/atoms/Image";
import Link from "components/atoms/Link";
import Text from "components/atoms/Text";
import UIPlaceholder from "components/atoms/UIPlaceholder";
import Layout from "components/layout";
import Article from "components/molecules/Article";
import CarouselItem from "components/molecules/Carousel/CarouselItem";
import CompareBlock from "components/molecules/CompareBlock";
import InfoBuyingForm from "components/molecules/InfoBuyingForm";
import LoadingBox from "components/molecules/LoadingBox";
import MethodService from "components/molecules/MethodService";
import Player from "components/molecules/player";
import Product from "components/molecules/Product";
import Promotioncard from "components/molecules/Promotioncard";
import { Tab, TabList, TabPanel, Tabs } from "components/molecules/Tabs";
import FilterProducts from "components/organisms/FilterProducts";
import Grid, { GridCol, GridRow } from "components/organisms/Grid";
import GridBannerPromotion from "components/organisms/GridBannerPromotion";
import GroupCardLink from "components/organisms/GroupCardLink";
import Section from "components/organisms/Section";
import { BASE_URL } from "constants/env";
import {
  COMMON_SECTION_PADDING,
  initialFilters,
  PRODUCT_FEATURE_IMAGE_RATIO,
  PRODUCT_TYPES
} from "constants/home";
import { minQuery, SizeMax, SizeMin } from "constants/media";
import { initialNotify } from "constants/notify";
import {
  CAROUSEL_IDS,
  PRODUCTS_FEATURE,
  PROMOTION_PRODUCT,
  SEEN_PRODUCT
} from "constants/swiper";
import { useSelector } from "hooks/useApp";
import useCompare from "hooks/useCompare";
import { useHomeGame } from "hooks/useHomeGame";
import useWindowSize from "hooks/useWindowSize";
import bgFeatureProduct from "images/common/background-product-feature.jpg";
import React, { lazy, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { onToggleBanner } from "redux/actions/general/toggleBanner";
import { requestFetchNewsCategories } from "redux/actions/news/list";
import { requestFetchHomePage } from "redux/actions/pages/home";
import { requestFetchProductsByType } from "redux/actions/products/byType";
import { requestFetchSeenProducts } from "redux/actions/products/seen";
import styled, { css } from "styled-components/macro";
import { SwiperSlide } from "swiper/react";
import { joinClassnames, mapMultiClassnames } from "utils/map-modifier";
import { isExternal } from "utils/utils-common";
import "./index.scss";
import HeroBanner, { SubBanner } from 'components/molecules/HeroBanner';
const Head = lazy(() => import("components/molecules/Head"));
const Modal = lazy(() => import("components/organisms/Modal"));
const ModalHeader = lazy(() => import("components/organisms/Modal/Header"));
const ModalBody = lazy(() => import("components/organisms/Modal/Body"));
const ModalFooter = lazy(() => import("components/organisms/Modal/Footer"));
const Carousel = lazy(() => import("components/molecules/Carousel"));
interface HomeProps { }

const Home: React.FC<HomeProps> = () => {
  const productType = {
    heading: "",
    image: "",
    image_mobile: "",
    data: [],
  };

  const [promotion, setPromotion] = useState({
    title: "",
    items: [],
  });

  const [convenientChoice, setConvenientChoice] = useState({
    image: "",
    heading: "",
    description: "",
  });
  const [promotionLoading, setPromotionLoading] = useState<boolean>();
  const [promotionProducts, setPromotionProducts] = useState<Array<{
    image: string;
    slug: string;
    banner: string;
    products: any
  }>>([]);
  const [splitProducts, setSplitProducts] = useState(productType);
  const [multiProducts, setMultiProducts] = useState(productType);
  const [airPurifierProducts, setAirPurifierProducts] = useState(productType);
  const [skyAirProducts, setSkyAirProducts] = useState(productType);
  const [seenList, setSeenList] = useState([]);
  const { seen } = useSelector(state => state.products);

  const [
    splitProductsHasCashbackLabel,
    setSplitProductsHasCashbackLabel,
  ] = useState(false);
  const [
    multiProductsHasCashbackLabel,
    setMultiProductsHasCashbackLabel,
  ] = useState(false);
  const [
    airPurifierProductsHasCashbackLabel,
    setAirPurifierProductsHasCashbackLabel,
  ] = useState(false);
  const [
    skyAirProductsHasCashbackLabel,
    setSkyAirProductsHasCashbackLabel,
  ] = useState(false);

  const [loadingHome, setLoadingHome] = useState(false);
  const [initToggleBanner, setInitToggleBanner] = useState(false);

  const [herocarousels, setHerocarousels] = useState([]);
  const [subHeroBanner, setSubHeroBanner] = useState<Array<SubBanner>>([]);
  const [methods, setMethods] = useState([]);
  const [bannerSrc, setBannerSrc] = useState(null);
  const [tipTitle, setTipTitle] = useState("");
  const [services, setServices] = useState<ServicesHomepage>();
  const [promotionBanner, serPromotionBanner] = useState<PromotionHomepage>();
  const [filterBanner, setfilterBannerBanner] = useState();

  const dispatch = useDispatch();
  const { home } = useSelector(state => state.pages);
  const { toggleBanner } = useSelector(state => state.general);
  const {
    byType: {
      data: { split, skyAir, multiSplit, airPurifier },
    },
  } = useSelector(state => state.products);
  const {
    compare: { data: compareList },
  } = useSelector(state => state.pages);
  const [notify, setNotify] = useState<NotifyType>(initialNotify);
  const { onCompare, goToCompare } = useCompare(compareList);
  const { news } = useSelector((state: any) => state.news.data);
  const history = useHistory();
  const { width } = useWindowSize();
  const MOBILE = 576;
  const PORTRAIT_TABLET = 768;
  const LANDSCAPE_TABLET = 1024;
  const [mobileClass, setMobileClass] = useState("");
  const [portraiTabletClass, setPortraiTabletClass] = useState("");
  const [desktopClass, setDesktopClass] = useState("");
  const [isMobile, setIsMobile] = useState(width <= MOBILE);

  const productIds = window.localStorage.getItem("productIds");

  const onCloseModal = () => {
    setNotify(initialNotify);
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const { data } = seen;
    if (data && Object.entries(data).length > 0) {
      setSeenList(data.data);
    }
  }, [seen]);

  useEffect(() => {
    const list = productIds && productIds.split(",").map(x => +x);
    if (list) {
      dispatch(
        requestFetchSeenProducts({
          list: list || [],
        }),
      );
    }
  }, [dispatch, productIds]);

  useEffect(() => {
    if (width <= MOBILE) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);

  useEffect(() => {
    if (splitProducts) {
      setSplitProductsHasCashbackLabel(
        splitProducts.data.filter(
          item => item.cashback_text !== null || item.cashback_img !== null,
        ).length > 0,
      );
    }
  }, [splitProducts]);
  useEffect(() => {
    if (multiProducts) {
      setMultiProductsHasCashbackLabel(
        multiProducts.data.filter(
          item => item.cashback_text !== null || item.cashback_img !== null,
        ).length > 0,
      );
    }
  }, [multiProducts]);
  useEffect(() => {
    if (airPurifierProducts) {
      setAirPurifierProductsHasCashbackLabel(
        airPurifierProducts.data.filter(
          item => item.cashback_text !== null || item.cashback_img !== null,
        ).length > 0,
      );
    }
  }, [airPurifierProducts]);
  useEffect(() => {
    if (skyAirProducts) {
      setSkyAirProductsHasCashbackLabel(
        skyAirProducts.data.filter(
          item => item.cashback_text !== null || item.cashback_img !== null,
        ).length > 0,
      );
    }
  }, [skyAirProducts]);

  useEffect(() => {
    if (promotion && promotion.items.length) {
      const notEnoughMobile =
        width < PORTRAIT_TABLET && promotion.items.length === 1;
      const notEnoughPortrait =
        width >= PORTRAIT_TABLET &&
        width < LANDSCAPE_TABLET &&
        promotion.items.length < 3;
      const notEnoughDesktop =
        width >= LANDSCAPE_TABLET && promotion.items.length < 4;
      if (notEnoughMobile || notEnoughPortrait || notEnoughDesktop) {
        setMobileClass(notEnoughMobile ? "notEnoughItemMobile" : "");
        setPortraiTabletClass(
          notEnoughPortrait ? "notEnoughItemPortraiTablet" : "",
        );
        setDesktopClass(notEnoughDesktop ? "notEnoughItemDesktop" : "");
      }
    }
  }, [width, promotion, promotion.items]);

  useEffect(() => {
    const { loading, data } = home;
    setLoadingHome(loading);

    if (data && Object.entries(data).length !== 0) {
      setHerocarousels(Object.values(data.page_meta_data?.home_section_sliders_91?.items || []));

      const home_section_sub_banners = Object.keys(data?.page_meta_data)?.find((meta) => meta?.includes('home_section_sub_banners'));

      let subBanners: Array<{
        src: string;
        srcMobile: string;
        link: string;
      }> = [];

      if (home_section_sub_banners) {
        subBanners = [
          {
            src: data.page_meta_data?.[home_section_sub_banners]?.sub_banner1 || '',
            srcMobile: data.page_meta_data?.[home_section_sub_banners]?.sub_banner_mobile1 || '',
            link: data.page_meta_data?.[home_section_sub_banners]?.link1 || '',
          },
          {
            src: data.page_meta_data?.[home_section_sub_banners]?.sub_banner2 || '',
            srcMobile: data.page_meta_data?.[home_section_sub_banners]?.sub_banner_mobile2 || '',
            link: data.page_meta_data?.[home_section_sub_banners]?.link2 || '',
          }
        ]
      }

      setSubHeroBanner(subBanners);

      const methods = Object.values(data.page_meta_data?.home_section_about_92?.items || []).map((item: any) => ({
        image: item.image,
        text: item.text,
        description: item.description_text,
      }));
      setServices(data.page_meta_data?.home_section_choose_service_114);
      serPromotionBanner(data.page_meta_data?.home_section_promotion_115);
      setfilterBannerBanner(data.page_meta_data?.home_section_banner_filter_116);

      setMethods(methods);
      setConvenientChoice({
        ...data.page_meta_data?.home_section_choose_products_94,
      });

      if (
        data.page_meta_data?.home_section_hot_promotion_93 &&
        data.page_meta_data?.home_section_hot_promotion_93?.items
      ) {
        setPromotion({
          ...promotion,
          title: data.page_meta_data?.home_section_hot_promotion_93?.heading,
          items: Object.values(data.page_meta_data?.home_section_hot_promotion_93?.items)
            .filter(item => !(!item || (item && !item.image && !item.link)))
            .map((pro, i) => ({
              id: i,
              ...pro,
            })),
        });
      } else {
        setPromotion({
          ...promotion,
          title: data.page_meta_data?.home_section_hot_promotion_93?.heading,
          items: [],
        });
      }

      setSplitProducts({
        ...splitProducts,
        ...data.page_meta_data?.home_section_product_list_95,
      });
      setMultiProducts({
        ...multiProducts,
        ...data.page_meta_data?.home_section_product_list_96,
      });
      setSkyAirProducts({
        ...skyAirProducts,

        // stagging: DÂN DỤNG CAO CẤP
        // live: MÁY LỌC KHÔNG KHÍ
        ...data.page_meta_data?.home_section_product_list_98,
      });

      setAirPurifierProducts({
        ...airPurifierProducts,

        // stagging: MÁY LỌC KHÔNG KHÍ
        // live: DÂN DỤNG CAO CẤP
        ...data.page_meta_data?.home_section_product_list_97,
      });
      setTipTitle(data.page_meta_data?.home_section_news_list_99?.heading);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [home]);

  const {
    // modalGame,
    popupLoading,
    setPopupLoading,
  } = useHomeGame();

  useEffect(() => {
    dispatch(requestFetchProductsByType(initialFilters.LOAI_2_DAN_ROI));
    dispatch(requestFetchProductsByType(initialFilters.MAY_LOC_KHONG_KHI));
    dispatch(requestFetchProductsByType(initialFilters.LOAI_MULTI));
    dispatch(requestFetchProductsByType(initialFilters.SKY_AIR));
    dispatch(requestFetchHomePage());
    requestFetchBlockBanner();
    dispatch(requestFetchNewsCategories());

    // disabled popup game loading behide:
    setTimeout(() => {
      setPopupLoading(false);
    }, 2500);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const requestFetchBlockBanner = () => {
    fetchBlockBanner()
      .then(rs => {
        if (rs.block_meta_data.image) {
          setBannerSrc(rs);
        }
        window.scrollTo(0, 0);
      })
      .catch(() => {
        window.scrollTo(0, 0);
      });
  };

  useEffect(() => {
    const { products } = split;
    if (products && products.length > 0) {
      setSplitProducts({
        ...splitProducts,
        data: products.filter(p => p.is_homepage === 1),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [split]);

  useEffect(() => {
    const { products } = multiSplit;
    if (products && products.length > 0) {
      setMultiProducts({
        ...multiProducts,
        data: products.filter(p => p.is_homepage === 1),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [multiSplit]);

  useEffect(() => {
    const { products } = airPurifier;
    if (products && products.length > 0) {
      setAirPurifierProducts({
        ...airPurifierProducts,
        data: products.filter(p => p.is_homepage === 1),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [airPurifier]);

  useEffect(() => {
    const { products } = skyAir;
    if (products && products.length > 0) {
      setSkyAirProducts({
        ...skyAirProducts,
        data: products.filter(p => p.is_homepage === 1),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skyAir]);

  useEffect(() => {
    dispatch(onToggleBanner());
    // window.scrollTo(0, 0);
    return () => {
      dispatch(onToggleBanner());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isCloseBanner = (e: any) => {
    e.preventDefault();
    dispatch(onToggleBanner());
  };

  useEffect(() => {
    setInitToggleBanner(
      toggleBanner.toggle === null ? false : toggleBanner.toggle,
    );
  }, [toggleBanner]);

  const [tips, setTips] = useState([]);
  useEffect(() => {
    if (news.length > 0) {
      setTips(news.slice(0, 4));
    }
  }, [news]);

  const [toggleInfoBuyingForm, setToggleInfoBuyingForm] = useState(false);
  const [idConsultProduct, setIdConsultProduct] = useState(0);

  const onToggleInfoBuyingForm = (id: number) => {
    setToggleInfoBuyingForm(true);
    setIdConsultProduct(id);
  };

  const onSubmitInfoBuyingForm = (result: boolean) => {
    setToggleInfoBuyingForm(false);
    setNotify({
      ...notify,
      status: true,
      type: "",
      message: result
        ? "Chúng tôi sẽ liên hệ quý khách trong thời gian sớm nhất"
        : "Thông tin gửi lên bị lỗi",
      error: !result,
    });
  };

  const [
    isAnimationConvenientChoice,
    setIsAnimationConvenientChoice,
  ] = useState(false);

  const [heroNavPosition, setHeroNavPosition] = useState();
  useEffect(() => {
    setTimeout(() => {
      getTopPositionIfHasHeroCarousel();
    }, 1000);
  }, []);

  const getTopPositionIfHasHeroCarousel = () => {
    const _hero = document.getElementsByClassName("m-herocarousel")[0];
    if (_hero) {
      setHeroNavPosition(_hero.clientHeight / 2);
    }
  };

  const [metaData, setMetaData] = useState<HeadData>();

  useEffect(() => {
    if (home.data) {
      const { meta_data } = home.data;

      if (meta_data && meta_data.translations) {
        const { translations } = meta_data;
        const { description, extra_data, keywords, title } = translations[0];
        setMetaData({
          titlePage: title,
          title,
          description,
          keywords,
          image: extra_data && extra_data.image,
        });
      }
    }
  }, [home.data]);

  useEffect(() => {
    setPromotionLoading(false);
    getPromotions({})
      .then(async (pro) => {
        const products = pro.meta.highlight?.products;
        const promotionPageTranslations = pro.meta.highlight?.promotionPageTranslations || [];

        const parseProducts: Array<string> = products ? JSON.parse(products) : [];
        const productsMeta = [...parseProducts];

        const productIds: Array<string[]> = pro.data.map((item) => item.products ? JSON.parse(item.products) : []);

        productIds.forEach((pr) => {
          pr.forEach((childPr) => {
            if (!productsMeta.includes(childPr)) productsMeta.push(childPr);
          });
        });

        const productIdsFinal = [...productsMeta];

        let searchProducts: Array<any> = [];

        try {
          const dataProductsData = await fetchSearchProducts({ ids: productIdsFinal.join(',') });
          searchProducts = [...dataProductsData?.products || []];
        } catch {
          // throw
        }

        const dataProducts = pro.data.map((item) => ({
          banner: item.promotionPageTranslations[0]?.banner || '',
          slug: item.promotionPageTranslations[0]?.slug || '',
          image: item.promotionPageTranslations[0]?.image || '',
          products: searchProducts.reduce((prev: Array<any>, cur) => {
            if (((item?.products && JSON.parse(item?.products)) || []).includes(String(cur?.id))) return prev.concat(cur);
            return prev;
          }, []).sort((a, b) => a?.id - b?.id)
        }));

        setPromotionProducts([
          {
            banner: promotionPageTranslations[0]?.banner || '',
            slug: promotionPageTranslations[0]?.slug || '',
            image: promotionPageTranslations[0]?.image || '',
            products: searchProducts.reduce((prev: Array<any>, cur) => {
              if (parseProducts.includes(String(cur?.id))) return prev.concat(cur);
              return prev;
            }, []).sort((a, b) => a?.id - b?.id)
          },
          ...dataProducts
        ]);
      })
      .catch(error => console.error(error))
      .finally(() => {
        setPromotionLoading(false);
      });
  }, []);

  const baseUrl = BASE_URL;

  return (
    <div className="p-home">
      <Layout>
        <Head data={metaData} />
        {loadingHome ? (
          <LoadingBox label="Đang tải dữ liệu..." />
        ) : (
          <>
            {
              //
              // Banner
              //
            }

            {herocarousels.length > 0 ? (
              isMobile ? (
                <HeroBanner
                  loop
                  autoplay={{ delay: 5000, disableOnInteraction: false }}
                  modifiers={["padding-btm"]}
                  className="home-hero no-padding-top"
                  pagination
                  subBanners={subHeroBanner}
                >
                  {herocarousels
                    .filter(item => item.image_mobile)
                    .map((item, i) => (
                      <SwiperSlide key={i}>
                        <CarouselItem>
                          <Link
                            href={item.link}
                            isLinkRouter={!isExternal(item.link)}
                            target={isExternal(item.link)}
                          >
                            <img src={item.image_mobile ? `${baseUrl}${item.image_mobile}` : ''} alt="" />
                          </Link>
                        </CarouselItem>
                      </SwiperSlide>
                    ))}
                </HeroBanner>
              ) : (
                <HeroBanner
                  loop
                  autoplay={{ delay: 5000, disableOnInteraction: false }}
                  modifiers={["padding-btm"]}
                  className="home-hero no-padding-top"
                  pagination
                  subBanners={subHeroBanner}
                >
                  {herocarousels
                    .filter(item => item.image)
                    .map((item, i) => (
                      <SwiperSlide key={i}>
                        <CarouselItem>
                          <Link
                            href={item.link}
                            isLinkRouter={!isExternal(item.link)}
                            target={isExternal(item.link)}
                          >
                            <img src={item.image ? `${baseUrl}${item.image}` : ''} alt="" />
                          </Link>
                        </CarouselItem>
                      </SwiperSlide>
                    ))}
                </HeroBanner>
              )
            ) : (
              <Text weight="bold" modifiers={["center"]}>
                Không có dữ liệu
              </Text>
            )}

            {
              //
              // Dịch vụ DAIKIN
              //
            }
            <Section className="daikin-list-services">
              {services && <GroupCardLink services={services} />}
            </Section>

            <Section space="space-xs" className="daikin-services">
              <MethodService methods={methods} />
            </Section>

            {
              //
              // VÌ SAO CHỌN DAIKIN E-SHOP
              //
            }
            {promotion && promotion.items.length > 0 ? (
              <Section
                className="reason-choosed-daikin-eshop"
                padding={COMMON_SECTION_PADDING}
              >
                <Heading type="h1" modifiers={["center"]} size="xl">
                  {promotion.title || ""}
                </Heading>
                <Grid>
                  <GridRow>
                    <GridCol>
                      <Carousel
                        pagination
                        breakpoints={PROMOTION_PRODUCT(promotion.items.length)}
                        slidesPerView={1}
                        modifiers={["padding-btm"]}
                        className={joinClassnames(
                          mobileClass,
                          portraiTabletClass,
                          desktopClass,
                          "promotion-carousel",
                        )}
                        rebuildOnUpdate
                        autoHeight={false}
                      >
                        {promotion.items &&
                          promotion.items.map((pro, i) => (
                            <SwiperSlide key={`promotion-${pro.id + i}`}>
                              <CarouselItem
                                ratio={0.5624674584}
                              >
                                <Promotioncard promotion={pro} />
                              </CarouselItem>
                            </SwiperSlide>
                          ))}
                      </Carousel>
                    </GridCol>
                  </GridRow>
                </Grid>
              </Section>
            ) : null}

            {promotionBanner &&
              promotionBanner.items &&
              Object.values(promotionBanner.items).every(item => item) && (
                <Section
                  className="daikin-promotion"
                  padding={COMMON_SECTION_PADDING}
                >
                  <Heading modifiers={["center"]}>
                    {promotionBanner.heading}
                  </Heading>
                  <GridBannerPromotion
                    listBanner={Object.values(promotionBanner.items).map(
                      item => ({
                        image: item.image ? baseUrl + item.image : '',
                        alt: item.alt,
                        link: item.link,
                      }),
                    )}
                  />
                </Section>
              )}

            {
              promotionLoading ? (
                <LoadingBox label="Đang tải dữ liệu..." />
              ) : (
                <>
                  {
                    promotionProducts.map((pro, index) => (
                      <Section
                        modifiers={["white"]}
                        className="daikin-seen-products"
                        padding={COMMON_SECTION_PADDING}
                        key={`promotion-product-${index.toString()}`}
                      >
                        <Grid>
                          <GridRow>
                            <GridCol>
                              <Link
                                href={
                                  "/khuyen-mai/" +
                                  pro.slug
                                }
                              >
                                <Image src={width < 768
                                  ? pro.image ? `${BASE_URL}${pro.image}` : ''
                                  : pro.banner ? `${BASE_URL}${pro.banner}` : ''} alt='promotion product' />
                              </Link>
                            </GridCol>
                            <GridCol>
                              {
                                <Carousel
                                  pagination={pro.products.length > 1}
                                  breakpoints={SEEN_PRODUCT()}
                                  hideNavigationAt={{ max: SizeMax.Small }}
                                  title={skyAirProducts.heading}
                                  id={`home-${CAROUSEL_IDS.SEEN_PRODUCTS}`}
                                  className={joinClassnames(
                                    `seen-products-carousels`,
                                    `${(pro.products.length < 3 && "list-less-than-3-item") ||
                                    (pro.products.length < 2 && "list-less-than-2-item") ||
                                    (pro.products.length <= 4 && "list-4-item")}`,
                                  )}
                                >
                                  {pro.products.map((product, index) => {
                                    return (
                                      <SwiperSlide key={`promotion-product-item-${index.toString()}`}>
                                        <CarouselItem>
                                          <Product
                                            product={product}
                                            addToCardButton={false}
                                            onCompare={onCompare}
                                            className="no-animate-item"
                                            hasCashbackLabel={skyAirProductsHasCashbackLabel}
                                            trademarks={
                                              product.trademarks &&
                                                product.trademarks.length > 0
                                                ? product.trademarks.map(tra => tra.name)
                                                : []
                                            }
                                            tags={
                                              product.tags && product.tags.length > 0
                                                ? product.tags.map((tag, index2) => (
                                                  <div
                                                    key={index2}
                                                    className="m-product_trademark_item service"
                                                  >
                                                    <Text modifiers={["primary"]} size="sm">
                                                      {tag.name}
                                                    </Text>
                                                  </div>
                                                ))
                                                : []
                                            }
                                            onToggleInfoBuyingForm={onToggleInfoBuyingForm}
                                          />
                                        </CarouselItem>
                                      </SwiperSlide>
                                    );
                                  })}
                                </Carousel>
                              }
                            </GridCol>
                          </GridRow>
                        </Grid>
                      </Section>
                    ))
                  }
                </>
              )
            }

            {
              //
              // LỰA CHỌN MÁY LẠNH PHÙ HỢP
              //
            }
            <Section
              bgrSrc={filterBanner && filterBanner.image1 ? `${baseUrl}${filterBanner && filterBanner.image1}` : ''}
              fullHeight
              className="daikin-filter daikin-filter-pc"
              padding={COMMON_SECTION_PADDING}
            >
              <Grid>
                <GridRow>
                  <GridCol>
                    <FilterProducts />
                  </GridCol>
                </GridRow>
              </Grid>
            </Section>
            {
              <Section
                className="daikin-filter daikin-filter-mobie"
                bgrSrc={filterBanner && filterBanner.image1 ? `${baseUrl}${filterBanner && filterBanner.image1}` : ''}
                fullHeight
                padding={COMMON_SECTION_PADDING}
              >
                <div className="s-convenient-choice">
                  {!isAnimationConvenientChoice && (
                    <div className="machine-selection">
                      <div className="machine-selection-info">
                        <Heading modifiers={["uppercase"]}>
                          Lựa chọn điều hòa phù hợp
                        </Heading>
                        <Text className="machine-selection-description">
                          Tìm kiếm sản phẩm phù hợp với nhu cầu sử dung thiết bị
                          điều hòa của bạn.
                        </Text>
                        <Button
                          variant="outline"
                          modifiers={["white"]}
                          type="button"
                          onClick={() =>
                            setIsAnimationConvenientChoice(
                              !isAnimationConvenientChoice,
                            )
                          }
                        >
                          Lựa chọn ngay
                        </Button>
                      </div>
                    </div>
                  )}

                  <div
                    className={joinClassnames(
                      "s-convenient-choice_mask",
                      isAnimationConvenientChoice && "show",
                    )}
                  >
                    <div
                      className={joinClassnames(
                        "s-convenient-choice_content",
                        isAnimationConvenientChoice && "show",
                      )}
                    >
                      <FilterProducts
                        // ref={convenientChoiceRef}
                        {...convenientChoice}
                        onCloseAnimation={() =>
                          setIsAnimationConvenientChoice(false)
                        }
                      />
                    </div>
                  </div>
                </div>
              </Section>
            }
          </>
        )}

        {
          //
          // Sản phẩm nổi bật
          //
        }
        <Section
          modifiers={["gray"]}
          className="daikin-products-feature"
          fullHeight
          bgrSrc={bgFeatureProduct}
          padding={COMMON_SECTION_PADDING}
        >
          <Heading modifiers={["center", "uppercase"]}>
            Sản phẩm nổi bật
          </Heading>
          <Grid>
            <Tabs>
              <TabList>
                {[
                  {
                    name: PRODUCT_TYPES.split.name,
                    title: "HAI DÀN RỜI",
                  },
                  {
                    name: PRODUCT_TYPES.multi.name,
                    title: "MULTI S",
                  },
                  {
                    name: PRODUCT_TYPES.airPurifier.name,
                    title: "MÁY LỌC KHÔNG KHÍ",
                  },
                ].map((bindingProducts, index) => (
                  <Tab key={index}>{bindingProducts.title}</Tab>
                ))}
              </TabList>

              {
                //
                // LOẠI HAI DẠNG RỜI
                //
              }
              {[
                {
                  name: PRODUCT_TYPES.split.name,
                  data: splitProducts.data,
                  cashBack: splitProductsHasCashbackLabel,
                },
                {
                  name: PRODUCT_TYPES.multi.name,
                  data: multiProducts.data,
                  cashBack: multiProductsHasCashbackLabel,
                },
                {
                  name: PRODUCT_TYPES.airPurifier.name,
                  data: airPurifierProducts.data,
                  cashBack: airPurifierProductsHasCashbackLabel,
                },
              ].map((bindingProducts, index1) => (
                <TabPanel key={index1}>
                  {bindingProducts.data.length > 0 && (
                    <Carousel
                      breakpoints={PRODUCTS_FEATURE()}
                      whiteHeading
                      id={`home-${CAROUSEL_IDS.SPLIT}`}
                      className={mapMultiClassnames(
                        `products-feature-carousels`,
                        bindingProducts.data.length === 1 && "single",
                      )}
                    >
                      {bindingProducts.data &&
                        bindingProducts.data.map(
                          (product: APIProduct, index2) => {
                            const {
                              name: productName,
                              trademarks,
                              tags: productTags,
                              images_highlight,
                            } = product;

                            const productImagesHighLight = Object.values(
                              images_highlight || {},
                            );

                            const result =
                              productImagesHighLight &&
                                productImagesHighLight.length
                                ? productImagesHighLight[0]
                                : {};

                            const {
                              thumb: productThumb,
                              youtube_embedded: productYoutubeEmbedded,
                            } = result;

                            return (
                              <SwiperSlide key={index2}>
                                <CarouselItem>
                                  <div className="product-feature">
                                    <Product
                                      product={product}
                                      addToCardButton={true}
                                      onCompare={onCompare}
                                      className="no-animate-item"
                                      hasCashbackLabel={bindingProducts.cashBack} //TO-CHECK:
                                      trademarks={
                                        trademarks && trademarks.length > 0
                                          ? trademarks.map(tra => tra.name)
                                          : []
                                      }
                                      tags={
                                        productTags && productTags.length > 0
                                          ? productTags.map((tag, indexTag) => (
                                            <div
                                              key={indexTag}
                                              className="m-product_trademark_item service"
                                            >
                                              <Text
                                                modifiers={["primary"]}
                                                size="sm"
                                              >
                                                {tag.name}
                                              </Text>
                                            </div>
                                          ))
                                          : []
                                      }
                                    />
                                    <div className="product-feature_wrapbanner">
                                      {!productThumb &&
                                        !productYoutubeEmbedded ? (
                                        <UIPlaceholder
                                          noBackground
                                          fullParent
                                          size="medium"
                                        >
                                          Chưa có hình ảnh
                                        </UIPlaceholder>
                                      ) : (
                                        <div className="product-feature_inner">
                                          {productThumb !== null ? (
                                            <Image
                                              src={`${BASE_URL}${productThumb}`}
                                              alt={productName}
                                              ratio={PRODUCT_FEATURE_IMAGE_RATIO}
                                            />
                                          ) : productYoutubeEmbedded !== null ? (
                                            <Player
                                              src={`${BASE_URL}/${productYoutubeEmbedded}`}
                                              ratio={PRODUCT_FEATURE_IMAGE_RATIO}
                                            />
                                          ) : (
                                            <UIPlaceholder
                                              noBackground
                                              fullParent
                                              size="medium"
                                            >
                                              Chưa có hình ảnh
                                            </UIPlaceholder>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </CarouselItem>
                              </SwiperSlide>
                            );
                          },
                        )}
                    </Carousel>
                  )}
                </TabPanel>
              ))}
            </Tabs>
          </Grid>
        </Section>

        {
          //
          // Mẹo hay
          //
        }
        {tips.length > 0 && (
          <Section
            modifiers={["white"]}
            className="section-tips"
            padding={COMMON_SECTION_PADDING}
          >
            <Grid>
              <GridRow>
                <GridCol>
                  <div className="titleSection">
                    <Heading>{tipTitle}</Heading>
                    <div
                      className="viewMore desktop"
                      onClick={() => history.push("/kinh-nghiem-hay")}
                    >
                      <Text weight="bold" modifiers={["primary"]}>
                        XEM THÊM
                      </Text>
                    </div>
                  </div>
                </GridCol>
                <GridCol colSm={12} colLg={6}>
                  <Article
                    imgSrc={`${BASE_URL}${tips[0].thumbnail}`}
                    category={tips[0].name_category}
                    title={tips[0].title}
                    slug={tips[0].slug}
                    description={tips[0].description}
                  />
                </GridCol>
                <GridCol colSm={12} colLg={6}>
                  {tips.map((tip, i) =>
                    i > 0 ? (
                      <StyledArticle
                        imgSrc={`${BASE_URL}${tip.thumbnail}`}
                        category={tip.name_category}
                        title={tip.title}
                        description={tip.description}
                        modifiers={["smallRow"]}
                        slug={tip.slug}
                        key={`${i}-id`}
                        className="article-small-home"
                      />
                    ) : null,
                  )}
                </GridCol>
              </GridRow>
            </Grid>
            <div
              className="viewMore mobile"
              onClick={() => history.push("/kinh-nghiem-hay")}
            >
              <Button variant="primary" modifiers={["rounded"]}>
                XEM THÊM
              </Button>
            </div>
          </Section>
        )}

        {
          //
          // Sản phẩm đã xem
          //
        }
        {seenList.length > 0 && (
          <Section
            modifiers={["gray"]}
            className="daikin-seen-products"
            padding={COMMON_SECTION_PADDING}
          >
            <Grid>
              <GridRow>
                <GridCol>
                  <div className="titleSection">
                    <Heading>SẢN PHẨM ĐÃ XEM</Heading>
                    <div
                      className="viewMore desktop"
                      onClick={() => history.push("/tai-khoan?t=seen-products")}
                    >
                      <Text weight="bold" modifiers={["primary"]}>
                        XEM TẤT CẢ
                      </Text>
                    </div>
                  </div>
                </GridCol>
                <GridCol>
                  {
                    <Carousel
                      pagination={seenList.length > 1}
                      breakpoints={SEEN_PRODUCT()}
                      hideNavigationAt={{ max: SizeMax.Small }}
                      title={skyAirProducts.heading}
                      id={`home-${CAROUSEL_IDS.SEEN_PRODUCTS}`}
                      className={joinClassnames(
                        `seen-products-carousels`,
                        `${(seenList.length < 3 && "list-less-than-3-item") ||
                        (seenList.length < 2 && "list-less-than-2-item") ||
                        (seenList.length <= 4 && "list-4-item")}`,
                      )}
                    >
                      {seenList.map((product, index) => {
                        return (
                          <SwiperSlide key={index}>
                            <CarouselItem>
                              <Product
                                product={product}
                                addToCardButton={false}
                                onCompare={onCompare}
                                className="no-animate-item"
                                hasCashbackLabel={skyAirProductsHasCashbackLabel}
                                trademarks={
                                  product.trademarks &&
                                    product.trademarks.length > 0
                                    ? product.trademarks.map(tra => tra.name)
                                    : []
                                }
                                tags={
                                  product.tags && product.tags.length > 0
                                    ? product.tags.map((tag, index2) => (
                                      <div
                                        key={index2}
                                        className="m-product_trademark_item service"
                                      >
                                        <Text modifiers={["primary"]} size="sm">
                                          {tag.name}
                                        </Text>
                                      </div>
                                    ))
                                    : []
                                }
                                onToggleInfoBuyingForm={onToggleInfoBuyingForm}
                              />
                            </CarouselItem>
                          </SwiperSlide>
                        );
                      })}
                    </Carousel>
                  }
                </GridCol>
              </GridRow>
            </Grid>
          </Section>
        )}

        {
          //
          // Compare block
          //
        }
        {compareList.length > 0 && (
          <div onClick={goToCompare}>
            <CompareBlock
              topPosition={heroNavPosition}
              count={compareList.length}
            />
          </div>
        )}
      </Layout>

      {
        //
        // Modal
        //
      }
      <Modal isOpen={notify.status} onCloseRequest={onCloseModal}>
        <ModalBody>
          <Text modifiers={["center", notify.error ? "error" : ""]}>
            {notify.message}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={onCloseModal}
            variant={notify.error ? "danger" : "primary"}
            size="small"
          >
            Đóng
          </Button>
        </ModalFooter>
      </Modal>

      {
        bannerSrc && (
          <Modal
            isOpen={initToggleBanner}
            noPadding
            onCloseRequest={() => {
              setInitToggleBanner(false);
            }}
            resetModal
          >
            <div className="o-modal_content_icon" onClick={e => isCloseBanner(e)}>
              <Icon iconName="x" />
            </div>
            <ModalBody>
              {popupLoading && <LoadingBox type="fill" />}
              {bannerSrc.block_meta_data.link ? (
                <Link href={bannerSrc.block_meta_data.link}>
                  <Image
                    src={`${BASE_URL}${bannerSrc.block_meta_data.image}`}
                    alt={bannerSrc.name}
                  />
                </Link>
              ) : (
                <Image
                  src={`${BASE_URL}${bannerSrc.block_meta_data.image}`}
                  alt={bannerSrc.name}
                />
              )}
            </ModalBody>
          </Modal>
        )
      }

      {
        skyAirProducts.data.length > 0 && (
          <Modal isOpen={toggleInfoBuyingForm} resetModal>
            <ModalHeader onCloseRequest={() => setToggleInfoBuyingForm(false)}>
              <Text size="lg" weight="bold" modifiers={["uppercase", "center"]}>
                thông tin mua hàng
              </Text>
              <Text modifiers={["center", "gray"]}>
                Xin quý khách vui lòng để lại thông tin để chúng tôi liên hệ tư
                vấn
              </Text>
            </ModalHeader>
            <ModalBody>
              <InfoBuyingForm
                productId={idConsultProduct}
                onSubmitInfoBuyingForm={onSubmitInfoBuyingForm}
              />
            </ModalBody>
          </Modal>
        )
      }

      {
        //
        // Games Popup from vender:
        //
      }
      {/* {modalGame} */}
    </div >
  );
};

const StyledArticle = styled(Article)`
  margin-top: 1.5rem;

  ${minQuery(
  SizeMin.Large,
  css`
      &:first-of-type {
        margin-top: 0;
      }
      &:not(:first-of-type) {
        margin-top: 2rem;
      }
    `,
)}
`;

export default Home;
